import { render, staticRenderFns } from "./dashboard_follow.vue?vue&type=template&id=34340538&scoped=true&"
import script from "./dashboard_follow.vue?vue&type=script&lang=js&"
export * from "./dashboard_follow.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_follow.vue?vue&type=style&index=0&id=34340538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34340538",
  null
  
)

export default component.exports